import dynamic from 'next/dynamic';
// import Sdk from '@/components/Sdk';
const Sdk  = dynamic(()=> import('@/components/Sdk'))
import Layout from '@/components/Layout';
// const Layout = dynamic(()=> import('@/components/Layout'))
Sdk.getLayout = function getLayout(page) {
  
    return (
        <Layout webViewMobile={true} web='p-sdk' >{page}</Layout>
    );
};

export default Sdk;


